export const DEFAULT_CUSTOM_OFFER_FIELD_LABELS = {
  ticketNumber: 'Salesforce case number',
  vendorReference: 'Supplier booking reference',
  salesDate: 'Sales date',
  agent: 'Wholesale Agent',
};

export const CRUISE_POST_PURCHASE_FIELD_LABELS = {
  ticketNumber: 'Ticket number',
  vendorReference: 'Vendor confirmation number',
  salesDate: 'Change date',
  agent: 'Concierge Agent',
};

export const getCustomOfferFieldLabels = (isCruisePostPurchase: boolean) =>
  isCruisePostPurchase ? CRUISE_POST_PURCHASE_FIELD_LABELS : DEFAULT_CUSTOM_OFFER_FIELD_LABELS;
